import styled from 'styled-components';

export const HeaderClockContainer = styled.div`
  @media (min-width: 960px) {
    & > div {
      background: ${props => props.theme.clockBg};
      padding: ${props => props.theme.clockPadding};
      font-size: 15px;
      border-radius: 15px;
      color: ${props => props.theme.clockColor};
      width: ${props => props.theme.clockWdith};
      flex-direction: row;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  @media (max-width: 960px) {
    & > div {
      background: ${props => props.theme.clockBg};
      padding: 8px 8%;
      font-size: 12px;
      border-radius: 15px;
      color: #fff;
      flex-direction: row;
      display: flex;
      justify-content: center;
    }
  }

  & > div > .clockText {
    margin-left: 5px;
    line-height: 1.7;
    font-size: ${props => props.theme.clockFont};
  }

  & > div > svg {
    height: 20px;
    width: 20px;
  }
`
